import React from "react"
// @ts-ignore
import { Link } from "react-router-dom"
import store from "src/store"
import Disclaimer from "./disclaimer"

export default function AskQuestionHeader() {
  store.useRerenderIfChange(() => [store.selectedReviewData.name])

  return (
    <div>
      <div>
        <Link
          css={`
            color: #799fd4;
            display: inline;
            cursor: pointer;
            text-decoration-line: underline;
          `}
          to="/my-reviews"
        >
          ← Back to my reviews
        </Link>
      </div>
      <div
        css={`
          font-size: 24px;
          color: #2e2e38;
          margin-top: 12px;
        `}
      >
        Ask question (AI)
      </div>
      <div
        css={`
          font-size: 16px;
          color: #2e2e38;
          margin-top: 12px;
        `}
      >
        <span>{store.selectedReviewData.name}</span>
      </div>
          <Disclaimer/>
    </div>
  )
}
